import React from 'react';
import get from 'lodash/get';

import { Button, Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  preview: {
    height: 150,
    width: '100%',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius * 2.5,
    border: `1px solid ${theme.palette.divider}`
  },
  uploadInput: {
    display: 'none !important' // Override styleguide display:block on input=["file"]
  },
  uppercase: {
    textTransform: 'uppercase'
  },
  actions: {
    display: 'flex',
    padding: theme.spacing(2, 0),
    justifyContent: 'space-between'
  }
}));

const hasFiles = e => get(e, 'target.files.length', 0) > 0;

export function FileUploader ({ field, value, onChange, accept = '.pdf' }) {
  const classes = useStyles();
  const formId = `${field}-image-upload`;

  const handleChange = (e) => {
    if (!(hasFiles(e))) {
      return;
    }
    onChange({ file: e.target.files[0] });
  };

  const handleClear = (e) => {
    e.preventDefault();
    onChange({ file: null });
  };

  return (
    <>
      <Grid container>
        <Paper elevation={0} className={classes.preview}>
          {value && value.file && <p>{value.file.name}</p>}
          {value && value.uri && <p>{value.uri}</p>}
        </Paper>
      </Grid>
      <Grid className={classes.actions}>
        <Button
          disabled={!value}
          variant='text'
          color='primary'
          onClick={handleClear}
          className={classes.uppercase}
        >
          <Translate content='remove' />
        </Button>
        <input
          data-testid='file-input'
          className={classes.uploadInput}
          onChange={handleChange}
          id={formId}
          type='file'
          accept={accept}
          value=''
        />
        <label htmlFor={formId}>
          <Button
            component='span'
            variant='text'
            color='primary'
            className={classes.uppercase}
          >
            <Translate content='pdf_editor_choose_file' />
          </Button>
        </label>
      </Grid>
    </>
  );
}

export default FileUploader;
